module.exports = __webpack_public_path__ + "static/MR_APR19_SOAT_600x600px-aff3e25670a418eea340b529d4dc9188.jpg";